export enum SearchEngineMethods {
    GET_END_DATES = "getEndDates",
    GET_AVAILABILITIES = "getAvailabilities",
}